interface GetSizeProps<T> {
  isLargeBp: boolean
  isMediumBp: boolean
  lg: T
  md: T
  sm: T
}

export const getGridConfig = <T>({ isLargeBp, isMediumBp, lg, md, sm }: GetSizeProps<T>, isVerticalGutter = false): string => {
  const getConfig = (config: T): string | null => (config !== undefined ? String(config) : null)

  const lgStyle = getConfig(lg)
  const mdStyle = getConfig(md)
  const smStyle = getConfig(sm)

  const breakPoints = {
    lg: lgStyle ?? (!isVerticalGutter ? mdStyle ?? smStyle : ''),
    md: mdStyle ?? (!isVerticalGutter ? smStyle : ''),
    sm: smStyle,
  }

  if (isLargeBp) {
    return breakPoints.lg ?? ''
  }
  if (isMediumBp) {
    return breakPoints.md ?? ''
  }
  return breakPoints.sm ?? ''
}
